import React from 'react';
import { Link } from 'react-router-dom';
import { TwitterIcon, LinkedinIcon, InstagramIcon } from 'lucide-react';
import { useLanguage, useTranslation } from '../i18n';
import type { Language } from '../i18n';
export function Footer() {
  const {
    language,
    setLanguage
  } = useLanguage();
  const {
    t
  } = useTranslation();
  const langs: Language[] = ['EN', 'FR', 'ES', 'PT'];
  return <footer className="bg-[#050505] relative z-20 pt-16 pb-8" data-id="element-38">
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-animated animate-shimmer-line" data-id="element-39"></div>

      <div className="max-w-7xl mx-auto px-6" data-id="element-40">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-41">
          <div className="col-span-1 md:col-span-1" data-id="element-42">
            <Link to="/" data-id="element-43">
              <img src="https://cdn.magicpatterns.com/uploads/7iLxTjsS92ZrEik9BZ7uDm/TRIPPP.png" alt="Trippp Logo" className="h-8 object-contain mb-6 opacity-80 hover:opacity-100 transition-opacity" data-id="element-44" />
            </Link>
            <p className="text-white/40 text-sm mb-6 max-w-[200px] leading-relaxed" data-id="element-45">
              {t('footer.tagline')}
            </p>
            <div className="flex space-x-4" data-id="element-46">
              <a href="#" className="text-white/40 hover:text-white transition-colors" data-id="element-47">
                <TwitterIcon className="w-5 h-5" data-id="element-48" />
              </a>
              <a href="#" className="text-white/40 hover:text-white transition-colors" data-id="element-49">
                <LinkedinIcon className="w-5 h-5" data-id="element-50" />
              </a>
              <a href="#" className="text-white/40 hover:text-white transition-colors" data-id="element-51">
                <InstagramIcon className="w-5 h-5" data-id="element-52" />
              </a>
            </div>
          </div>

          <div data-id="element-53">
            <h4 className="text-white font-semibold mb-4" data-id="element-54">
              {t('footer.products')}
            </h4>
            <ul className="space-y-3" data-id="element-55">
              <li data-id="element-56">
                <Link to="/products/map" className="text-white/50 hover:text-white text-sm transition-colors" data-id="element-57">
                  Trippp Map
                </Link>
              </li>
              <li data-id="element-58">
                <Link to="/products/spark" className="text-white/50 hover:text-white text-sm transition-colors" data-id="element-59">
                  Trippp Spark
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/products/ops" className="text-white/50 hover:text-white text-sm transition-colors" data-id="element-61">
                  Trippp Ops
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/pricing" className="text-white/50 hover:text-white text-sm transition-colors" data-id="element-63">
                  {t('navbar.pricing')}
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-64">
            <h4 className="text-white font-semibold mb-4" data-id="element-65">
              {t('footer.company')}
            </h4>
            <ul className="space-y-3" data-id="element-66">
              <li data-id="element-67">
                <Link to="/about" className="text-white/50 hover:text-white text-sm transition-colors" data-id="element-68">
                  {t('footer.aboutUs')}
                </Link>
              </li>
              <li data-id="element-69">
                <a href="#" className="text-white/50 hover:text-white text-sm transition-colors" data-id="element-70">
                  {t('footer.careers')}
                </a>
              </li>
              <li data-id="element-71">
                <a href="#" className="text-white/50 hover:text-white text-sm transition-colors" data-id="element-72">
                  {t('footer.blog')}
                </a>
              </li>
              <li data-id="element-73">
                <Link to="/contact" className="text-white/50 hover:text-white text-sm transition-colors" data-id="element-74">
                  {t('footer.contact')}
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-75">
            <h4 className="text-white font-semibold mb-4" data-id="element-76">
              {t('footer.language')}
            </h4>
            <div className="flex flex-wrap gap-2" data-id="element-77">
              {langs.map(lang => <button key={lang} type="button" onClick={() => setLanguage(lang)} className={`px-3 py-1 rounded-md text-xs font-medium transition-colors ${language === lang ? 'bg-white/10 text-white' : 'bg-transparent border border-white/10 text-white/50 hover:text-white hover:border-white/30'}`} data-id="element-78">
                  {lang}
                </button>)}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-79">
          <p className="text-white/40 text-xs" data-id="element-80">
            {t('footer.copyright').replace('{year}', new Date().getFullYear().toString())}
          </p>
          <div className="flex space-x-6" data-id="element-81">
            <a href="#" className="text-white/40 hover:text-white text-xs transition-colors" data-id="element-82">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-white/40 hover:text-white text-xs transition-colors" data-id="element-83">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}